var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7 17.1c-0.2-0.4-0.5-0.8-0.8-1.4l-0.8-1.3c-0.7-1.2-1.2-2.6-1.4-4l-0.3-3     C19.8 3.1 16.3 0 12 0C7.7 0 4.2 3.1 3.7 7.2l-0.3 3c-0.2 1.4-0.6 2.8-1.4 4l-0.8 1.3     c-0.3 0.6-0.6 1-0.8 1.4c-0.2 0.4-0.3 0.8-0.3 1.2c0.1 0.5 0.3 0.9 0.7 1.2     C1.1 19.8 1.5 20 2 20h5.4c0.3 1.1 0.9 2.1 1.7 2.8C9.9 23.6 10.9 24 12 24     c1 0 2.1-0.4 2.9-1.1c0.8-0.7 1.4-1.7 1.7-2.8H22c0.5 0 0.9-0.1 1.2-0.4     c0.4-0.3 0.6-0.7 0.7-1.2c0.1-0.4-0.1-0.8-0.3-1.2z",
    stroke: "#1C1B1F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bellIcon.6b281a1e2f11a9021555e8acb6932d6f.svg";
export { ForwardRef as ReactComponent };